import React, { useState, useEffect } from "react";
import { MdClose, MdUpdate, MdEdit, MdWarning } from "react-icons/md";
import { usersAPI } from "services/api";

const StaffEditModal = ({ staffId, onClose }) => {
    // --- STATELER (StaffEdit.js'den Birebir Work-Logic) ---
    const [formData, setFormData] = useState({
        name: "",
        surname: "",
        phone: "",
        email: "",
        password: "", // Düzenlemede opsiyoneldir
        role: "staff",
        birth_date: "",
        tag: "",
    });

    const [isFetching, setIsFetching] = useState(true); // Veri çekilirken
    const [isSubmitting, setIsSubmitting] = useState(false); // Kaydedilirken
    const [error, setError] = useState(null);

    // --- VERİ ÇEKME (Component yüklendiğinde personeli getirir) ---
    useEffect(() => {
        let mounted = true;

        const fetchStaffDetails = async () => {
            if (!staffId) return;
            setIsFetching(true);
            setError(null);

            try {
                const response = await usersAPI.getById(staffId);
                if (mounted && response.success) {
                    const user = response.user;
                    setFormData({
                        name: user.name || "",
                        surname: user.surname || "",
                        phone: user.phone || "",
                        email: user.email || "",
                        role: user.role || "staff",
                        password: "", // Şifre backend'den gelmez, boş bırakılır
                        birth_date: user.birth_date ? user.birth_date.split("T")[0] : "", // Tarihi inputa uygun formatlama
                        tag: user.tag || "",
                    });
                }
            } catch (err) {
                if (mounted) setError(err.response?.data?.message || "Personel bilgileri alınamadı.");
            } finally {
                if (mounted) setIsFetching(false);
            }
        };

        fetchStaffDetails();

        return () => {
            mounted = false;
        };
    }, [staffId]);

    // --- İŞLEYİCİLER ---
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setError(null);

        try {
            // API'ye gönderilecek payload (Eğer şifre girilmediyse, backend'e boş gider veya backend ignore eder)
            const payload = { ...formData };
            if (!payload.password) {
                delete payload.password; // Şifre değiştirilmek istenmiyorsa payload'dan çıkarılır
            }

            await usersAPI.update(staffId, payload);
            onClose(); // İşlem başarılıysa modalı kapat ve listeyi yenilemeye tetik at
        } catch (err) {
            setError(err.response?.data?.message || "Güncelleme sırasında bir hata oluştu.");
        } finally {
            setIsSubmitting(false);
        }
    };

    // Eğer ID yoksa hiç renderlama
    if (!staffId) return null;

    return (
        // ARKAPLAN (BUZLU CAM)
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-navy-900/40 backdrop-blur-sm p-4 transition-all">

            {/* MODAL KARTI */}
            <div className="relative w-full max-w-3xl bg-white dark:bg-navy-800 rounded-[24px] shadow-2xl overflow-hidden flex flex-col max-h-[90vh] animate-fadeIn">

                {/* HEADER */}
                <div className="flex-none flex items-center justify-between p-6 border-b border-gray-100 dark:border-white/10 bg-white dark:bg-navy-800">
                    <div className="flex items-center gap-4">
                        <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-amber-500 text-white shadow-lg shadow-amber-500/30">
                            <MdEdit className="text-2xl" />
                        </div>
                        <div>
                            <h3 className="text-xl font-bold text-navy-700 dark:text-white">Personel Düzenle</h3>
                            <p className="text-sm font-medium text-gray-500 dark:text-gray-400 mt-0.5">Personel bilgilerini ve yetkilerini güncelleyin</p>
                        </div>
                    </div>
                    <button
                        onClick={onClose}
                        className="flex h-10 w-10 items-center justify-center rounded-full text-gray-500 hover:bg-gray-100 dark:hover:bg-navy-700 dark:text-gray-400 transition-all"
                    >
                        <MdClose className="text-2xl" />
                    </button>
                </div>

                {/* BODY (KAYDIRILABİLİR İÇERİK VEYA LOADER) */}
                <div className="flex-1 overflow-y-auto custom-modal-scroll p-6 bg-white dark:bg-navy-800">

                    {error && (
                        <div className="mb-6 flex items-center gap-3 rounded-xl bg-red-50 p-4 text-red-600 dark:bg-red-500/10 dark:text-red-400 border border-red-100 dark:border-red-500/20">
                            <MdWarning className="text-xl flex-none" />
                            <p className="text-sm font-bold">{error}</p>
                        </div>
                    )}

                    {isFetching ? (
                        // Veri Yüklenirken Gösterilecek Şık İskelet (Skeleton)
                        <div className="flex flex-col gap-5 animate-pulse py-4">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                                <div className="h-12 w-full rounded-xl bg-gray-200 dark:bg-navy-700" />
                                <div className="h-12 w-full rounded-xl bg-gray-200 dark:bg-navy-700" />
                            </div>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                                <div className="h-12 w-full rounded-xl bg-gray-200 dark:bg-navy-700" />
                                <div className="h-12 w-full rounded-xl bg-gray-200 dark:bg-navy-700" />
                            </div>
                            <div className="h-12 w-full rounded-xl bg-gray-200 dark:bg-navy-700" />
                            <div className="flex items-center justify-center py-6">
                                <div className="h-8 w-8 border-4 border-amber-500 border-t-transparent rounded-full animate-spin" />
                            </div>
                        </div>
                    ) : (
                        // Form Alanı
                        <form id="editStaffForm" onSubmit={handleSubmit} className="flex flex-col gap-5">

                            {/* 1. SATIR: İsim / Soyisim */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                                <div>
                                    <label className="text-sm font-bold text-navy-700 dark:text-white ml-1 mb-2 block">Ad *</label>
                                    <input
                                        required
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        className="flex h-12 w-full items-center justify-center rounded-xl border border-gray-200 bg-white/0 p-3 text-sm font-medium text-navy-700 outline-none focus:border-brand-500 dark:border-white/10 dark:text-white dark:focus:border-brand-400 transition-all"
                                    />
                                </div>
                                <div>
                                    <label className="text-sm font-bold text-navy-700 dark:text-white ml-1 mb-2 block">Soyad *</label>
                                    <input
                                        required
                                        name="surname"
                                        value={formData.surname}
                                        onChange={handleChange}
                                        className="flex h-12 w-full items-center justify-center rounded-xl border border-gray-200 bg-white/0 p-3 text-sm font-medium text-navy-700 outline-none focus:border-brand-500 dark:border-white/10 dark:text-white dark:focus:border-brand-400 transition-all"
                                    />
                                </div>
                            </div>

                            {/* 2. SATIR: Telefon / E-Posta */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                                <div>
                                    <label className="text-sm font-bold text-navy-700 dark:text-white ml-1 mb-2 block">Telefon *</label>
                                    <input
                                        required
                                        name="phone"
                                        value={formData.phone}
                                        onChange={handleChange}
                                        className="flex h-12 w-full items-center justify-center rounded-xl border border-gray-200 bg-white/0 p-3 text-sm font-medium text-navy-700 outline-none focus:border-brand-500 dark:border-white/10 dark:text-white dark:focus:border-brand-400 transition-all"
                                    />
                                </div>
                                <div>
                                    <label className="text-sm font-bold text-navy-700 dark:text-white ml-1 mb-2 block">E-Posta *</label>
                                    <input
                                        required
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        className="flex h-12 w-full items-center justify-center rounded-xl border border-gray-200 bg-white/0 p-3 text-sm font-medium text-navy-700 outline-none focus:border-brand-500 dark:border-white/10 dark:text-white dark:focus:border-brand-400 transition-all"
                                    />
                                </div>
                            </div>

                            {/* 3. SATIR: Şifre Değiştirme (Opsiyonel) */}
                            <div>
                                <label className="text-sm font-bold text-navy-700 dark:text-white ml-1 mb-2 block flex items-center justify-between">
                                    <span>Yeni Şifre</span>
                                    <span className="text-[10px] font-medium text-amber-500 bg-amber-50 dark:bg-amber-500/10 px-2 py-0.5 rounded">Opsiyonel</span>
                                </label>
                                <input
                                    type="password"
                                    name="password"
                                    value={formData.password}
                                    onChange={handleChange}
                                    className="flex h-12 w-full items-center justify-center rounded-xl border border-gray-200 bg-white/0 p-3 text-sm font-medium text-navy-700 outline-none focus:border-amber-500 dark:border-white/10 dark:text-white dark:focus:border-amber-400 transition-all placeholder:text-gray-400"
                                    placeholder="Değiştirmek istemiyorsanız boş bırakın"
                                />
                            </div>

                            {/* 4. SATIR: Rol, Doğum Tarihi, Etiket */}
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                                <div>
                                    <label className="text-sm font-bold text-navy-700 dark:text-white ml-1 mb-2 block">Rol</label>
                                    <select
                                        name="role"
                                        value={formData.role}
                                        onChange={handleChange}
                                        className="flex h-12 w-full items-center justify-center rounded-xl border border-gray-200 bg-white/0 p-3 text-sm font-bold text-navy-700 outline-none focus:border-brand-500 dark:border-white/10 dark:bg-navy-900 dark:text-white transition-all appearance-none"
                                    >
                                        <option value="staff">Personel</option>
                                        <option value="admin">Yönetici</option>
                                    </select>
                                </div>
                                <div>
                                    <label className="text-sm font-bold text-navy-700 dark:text-white ml-1 mb-2 block">Doğum Tarihi</label>
                                    <input
                                        type="date"
                                        name="birth_date"
                                        value={formData.birth_date}
                                        onChange={handleChange}
                                        className="flex h-12 w-full items-center justify-center rounded-xl border border-gray-200 bg-white/0 p-3 text-sm font-medium text-navy-700 outline-none focus:border-brand-500 dark:border-white/10 dark:text-white dark:focus:border-brand-400 transition-all"
                                    />
                                </div>
                                <div>
                                    <label className="text-sm font-bold text-navy-700 dark:text-white ml-1 mb-2 block">Etiket</label>
                                    <input
                                        name="tag"
                                        value={formData.tag}
                                        onChange={handleChange}
                                        className="flex h-12 w-full items-center justify-center rounded-xl border border-gray-200 bg-white/0 p-3 text-sm font-medium text-navy-700 outline-none focus:border-brand-500 dark:border-white/10 dark:text-white dark:focus:border-brand-400 transition-all"
                                        placeholder="Örn: Kuaför"
                                    />
                                </div>
                            </div>

                        </form>
                    )}
                </div>

                {/* FOOTER (BUTONLAR) */}
                <div className="flex-none flex items-center justify-end gap-3 p-6 border-t border-gray-100 dark:border-white/10 bg-gray-50 dark:bg-navy-800/50">
                    <button
                        type="button"
                        onClick={onClose}
                        className="flex h-12 items-center justify-center rounded-xl px-6 text-sm font-bold text-gray-600 hover:bg-gray-200 dark:text-gray-300 dark:hover:bg-navy-700 transition-all"
                    >
                        Vazgeç
                    </button>
                    <button
                        type="submit"
                        form="editStaffForm"
                        disabled={isSubmitting || isFetching}
                        className="flex h-12 items-center justify-center gap-2 rounded-xl bg-amber-500 px-8 text-sm font-bold text-white shadow-lg shadow-amber-500/30 hover:bg-amber-600 disabled:opacity-70 disabled:cursor-not-allowed transition-all active:scale-95"
                    >
                        {isSubmitting ? (
                            <div className="h-5 w-5 animate-spin rounded-full border-2 border-white border-t-transparent" />
                        ) : (
                            <><MdUpdate className="text-lg" /> Bilgileri Güncelle</>
                        )}
                    </button>
                </div>

            </div>

            {/* İç Scrollbar Tasarımı */}
            <style jsx="true">{`
        .custom-modal-scroll::-webkit-scrollbar { width: 6px; }
        .custom-modal-scroll::-webkit-scrollbar-track { background: transparent; }
        .custom-modal-scroll::-webkit-scrollbar-thumb { background: rgba(163, 174, 208, 0.3); border-radius: 10px; }
        .dark .custom-modal-scroll::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.1); }
      `}</style>
        </div>
    );
};

export default StaffEditModal;